ListeVilla = {

	init : ->
		console.log "Liste Villa init"

		
		if not Config.isMobile()
			@stickyManager()

	stickyManager : ->
		
		setTimeout ->

			introSlider = $('.page-liste-villas .presentation--slider')
			sliderHeight = parseInt introSlider.height()
			blockHeight = parseInt $('.block-presentation .presentation--right').height() 
			if sliderHeight / 2 < blockHeight
				distanceToScroll = parseInt($('.block-presentation').height()) - parseInt($('.block-presentation').css('padding-top'))
				scene = new ScrollMagic.Scene({triggerElement: '.presentation--title', duration: distanceToScroll - introSlider.height(), triggerHook: 0.1, force3D:true})
					.setPin(introSlider[0])
					.addTo(App.controller)
			else 
				$('.block-presentation .presentation--right').height(sliderHeight / 2) 
		, 300

	destroy : ->
		console.log "Liste Villa destroy"
}

